/**
 * Renders a tiny subset of markdown as safe HTML.
 *
 * Supports:
 *  - `**bold**` → `<strong>bold</strong>`
 *
 * HTML special characters in the input are escaped first, so the only HTML in
 * the output comes from this function's own transformations — the result is
 * safe to assign to `innerHTML` even with content of unknown origin.
 */
export function renderInline(text: string): string {
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  return escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
}
